// extracted by mini-css-extract-plugin
module.exports = {"input_box_div":"DebtInformation_input_box_div__2Z_5q","dollor_icon":"DebtInformation_dollor_icon__3_1B5"};